import React from "react";
import {
  Drawer,
  DrawerContent,
  DrawerOverlay,
  PopoverTrigger,
  Popover,
  Button,
  PopoverBody,
  PopoverContent,
  PopoverArrow,
  Stack,
  DrawerBody,
} from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Link } from "gatsby";

const SideMenu = (props) => {
  const { setVisible, visible } = props;

  return (
    <Drawer placement="left" isOpen={visible} onClose={setVisible}>
      <DrawerOverlay>
        <DrawerContent>
          <DrawerBody>
            <Stack>
              <Button as={Link} to="/about" variant="outline">
                About
              </Button>
              <Popover trigger="hover" placement="right">
                <PopoverTrigger>
                  <Button
                    as={Link}
                    to="/about/editorial-policies"
                    variant="outline"
                    rightIcon={<ChevronRightIcon />}
                  >
                    Editorial Policies
                  </Button>
                </PopoverTrigger>
                <PopoverContent>
                  <PopoverArrow />
                  <PopoverBody>
                    <Stack>
                      <Button
                        as={Link}
                        to="/about/editorial-policies/editorial-board-and-staff"
                        variant="outline"
                        isFullWidth
                      >
                        Editorial Staff
                      </Button>
                      <Button
                        as={Link}
                        to="/about/editorial-policies/micropublication-biology-editorial-board"
                        variant="outline"
                        isFullWidth
                      >
                        Editorial Board
                      </Button>
                      <Button
                        as={Link}
                        to="/about/editorial-policies/publishing-information"
                        variant="outline"
                        isFullWidth
                      >
                        Publishing Information
                      </Button>
                      <Button
                        as={Link}
                        to="/data-sharing-policy"
                        variant="outline"
                        isFullWidth
                      >
                        Data Sharing Policy
                      </Button>
                    </Stack>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
              <Popover trigger="hover" placement="right" variant="responsive">
                <PopoverTrigger>
                  <Button
                    as={Link}
                    to="/about/for-authors"
                    variant="outline"
                    rightIcon={<ChevronRightIcon />}
                  >
                    For Authors
                  </Button>
                </PopoverTrigger>
                <PopoverContent>
                  <PopoverArrow />
                  <PopoverBody>
                    <Stack>
                      <Button
                        as={Link}
                        to="/about/for-authors#signing-up-and-signing-on"
                        variant="outline"
                        isFullWidth
                      >
                        Preparation And Submission Of A Manuscript
                      </Button>
                      <Button
                        as={Link}
                        to="/about/for-authors#peer-review-process"
                        variant="outline"
                        isFullWidth
                      >
                        Peer Review Process
                      </Button>
                      <Button
                        as={Link}
                        to="/about/for-authors#following-publication"
                        variant="outline"
                        isFullWidth
                      >
                        Following Acceptance
                      </Button>
                      <Button
                        as={Link}
                        to="/about/for-authors#appeals"
                        variant="outline"
                        isFullWidth
                      >
                        Appeals
                      </Button>
                    </Stack>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
              <Button as={Link} to="/about/for-reviewers" variant="outline">
                For Reviewers
              </Button>
              <Button as={Link} to="/about#why-micropublish?" variant="outline">
                Why micropublish?
              </Button>
              <Button as={Link} to="/submit-new-article" variant="outline">
                Submit a microPublication
              </Button>
              <Button as={Link} to="/journals/biology" variant="outline">
                All microPublications
              </Button>
              <Popover trigger="hover" placement="right">
                <PopoverTrigger>
                  <Button variant="outline" rightIcon={<ChevronRightIcon />}>
                    Species
                  </Button>
                </PopoverTrigger>
                <PopoverContent p={0}>
                  <PopoverArrow />
                  <PopoverBody>
                    <Stack>
                      <Button
                        as={Link}
                        to="/journals/biology/species/arabidopsis"
                        variant="outline"
                        isFullWidth
                      >
                        Arabidopsis
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/species/c. elegans"
                        variant="outline"
                        isFullWidth
                      >
                        C. elegans
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/species/drosophila"
                        variant="outline"
                        isFullWidth
                      >
                        Drosophila
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/species/mouse"
                        variant="outline"
                        isFullWidth
                      >
                        Mouse
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/species/s. cerevisiae"
                        variant="outline"
                        isFullWidth
                      >
                        S. cerevisiae
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/species/xenopus"
                        variant="outline"
                        isFullWidth
                      >
                        Xenopus
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/species/zebrafish"
                        variant="outline"
                        isFullWidth
                      >
                        Zebrafish
                      </Button>
                    </Stack>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
              <Popover trigger="hover" placement="right">
                <PopoverTrigger>
                  <Button variant="outline" rightIcon={<ChevronRightIcon />}>
                    Categories
                  </Button>
                </PopoverTrigger>
                <PopoverContent p={0}>
                  <PopoverArrow />
                  <PopoverBody>
                    <Stack>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/phenotype data"
                        variant="outline"
                        isFullWidth
                      >
                        Phenotype Data
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/methods"
                        variant="outline"
                        isFullWidth
                      >
                        Methods
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/expression data"
                        variant="outline"
                        isFullWidth
                      >
                        Expression Data
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/genotype data"
                        variant="outline"
                        isFullWidth
                      >
                        Genotype Data
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/integrations"
                        variant="outline"
                        isFullWidth
                      >
                        Integrations
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/genetic screens"
                        variant="outline"
                        isFullWidth
                      >
                        Genetic Screens
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/models of human disease"
                        variant="outline"
                        isFullWidth
                      >
                        Models of Human Disease
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/software"
                        variant="outline"
                        isFullWidth
                      >
                        Software
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/interaction data"
                        variant="outline"
                        isFullWidth
                      >
                        Interaction Data
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/database updates"
                        variant="outline"
                        isFullWidth
                      >
                        Database Updates
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/electrophysiology data"
                        variant="outline"
                        isFullWidth
                      >
                        Electrophysiology Data
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/phylogenetic data"
                        variant="outline"
                        isFullWidth
                      >
                        Phylogenetic Data
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/science and society"
                        variant="outline"
                        isFullWidth
                      >
                        Science and Society
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/categories/biochemistry"
                        variant="outline"
                        isFullWidth
                      >
                        Biochemistry
                      </Button>
                    </Stack>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
              <Popover trigger="hover" placement="right">
                <PopoverTrigger>
                  <Button variant="outline" rightIcon={<ChevronRightIcon />}>
                    Article Types
                  </Button>
                </PopoverTrigger>
                <PopoverContent p={0}>
                  <PopoverArrow />
                  <PopoverBody>
                    <Stack>
                      <Button
                        as={Link}
                        to="/journals/biology/types/new finding"
                        variant="outline"
                        isFullWidth
                      >
                        New Finding
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/new methods"
                        variant="outline"
                        isFullWidth
                      >
                        New Methods
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/materials and reagents"
                        variant="outline"
                        isFullWidth
                      >
                        Materials and Reagents
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/negative result"
                        variant="outline"
                        isFullWidth
                      >
                        Negative Result
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/software"
                        variant="outline"
                        isFullWidth
                      >
                        Software
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/commodity validation"
                        variant="outline"
                        isFullWidth
                      >
                        Commodity Validation
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/data updates"
                        variant="outline"
                        isFullWidth
                      >
                        Data Updates
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/findings previously not shown"
                        variant="outline"
                        isFullWidth
                      >
                        Findings Previously Not Shown
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/replication successful"
                        variant="outline"
                        isFullWidth
                      >
                        Replication Successful
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/replication unsuccessful"
                        variant="outline"
                        isFullWidth
                      >
                        Replication Unsuccessful
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/corrigendum"
                        variant="outline"
                        isFullWidth
                      >
                        Corrigendum
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/erratum"
                        variant="outline"
                        isFullWidth
                      >
                        Erratum
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/retracted"
                        variant="outline"
                        isFullWidth
                      >
                        Retracted
                      </Button>
                      <Button
                        as={Link}
                        to="/journals/biology/types/retraction"
                        variant="outline"
                        isFullWidth
                      >
                        Retraction
                      </Button>
                    </Stack>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
              <Button as={Link} to="/contact-us" variant="outline">
                Contact
              </Button>
              <Button as={Link} to="/archives" variant="outline">
                Archives
              </Button>
              <Button as={Link} to="/faqs" variant="outline">
                FAQs
              </Button>
              <Button as={Link} to="/newsletter" variant="outline">
                Newsletter
              </Button>
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};

export default SideMenu;
